(function () {
  if (window.__mpnInfo) return; window.__mpnInfo = true;
  var CLOSE = window.__mpnInfoClose;
  var SEL = '.mpn-pal__ib,.mpn-fmt__i,.mpn-dims__ib,.mpn-margin__i,.product__cuttings-info,.sample-block__info';
  var pop = null, cur = null;
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  /* Titre + contenu de chaque « i » (le contenu existe déjà dans la page, on le reprend tel quel) */
  function content(b) {
    var t = '', h = '', box;
    if (b.matches('.mpn-pal__ib')) {
      box = b.closest('[data-mpn-pal]');
      var inf = box && box.querySelector('[data-mpn-pal-info]');
      t = inf ? (inf.getAttribute('data-title') || '') : '';
      h = inf ? inf.innerHTML : '';
    } else if (b.matches('.mpn-fmt__i')) {
      box = b.closest('.mpn-fmt__sec');
      t = txt(box && box.querySelector('.mpn-fmt__st'));
      var tip = box && box.querySelector('.mpn-fmt__tip');
      h = tip ? tip.innerHTML : '';
    } else if (b.matches('.mpn-dims__ib')) {
      var li = b.closest('.mpn-dims__i');
      t = txt(li && li.querySelector('[data-l]'));
      var host = b.closest('[data-mpn-dims-host]') || document;
      var note = host.querySelector('[data-mpn-note]');
      h = note ? note.innerHTML : '';
    } else if (b.matches('.mpn-margin__i')) {
      var mp = (b.closest('.mpn-margin__head') || document).querySelector('[data-mpn-margin-pop]');
      if (mp) {
        var c = mp.cloneNode(true);
        var x = c.querySelector('[data-mpn-margin-pop-close]'); if (x) x.remove();
        var tt = c.querySelector('.mpn-margin__pop-title'); if (tt) { t = txt(tt); tt.remove(); }
        h = c.innerHTML;
      }
    } else if (b.matches('.product__cuttings-info')) {
      var lb = b.closest('.product__cuttings'); lb = lb && lb.querySelector('label');
      t = txt(lb);
      var sp = b.querySelector(':scope > span'); h = sp ? sp.innerHTML : '';
    } else if (b.matches('.sample-block__info')) {
      var sb = b.closest('.sample-block, [class*="sample-block"]');
      var ti = sb && sb.querySelector('h2, h3, h4, .sample-block__title, [class*="__title"]');
      t = txt(ti);
      var sc = b.querySelector('.sample-block__info-content'); h = sc ? sc.innerHTML : '';
    }
    if (h && !/<(p|div|ul|svg)\b/i.test(h)) h = '<p>' + h + '</p>';
    return { t: t, h: h };
  }
  function ensure() {
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'mpn-info-pop'; pop.hidden = true;
    pop.setAttribute('role', 'dialog');
    pop.innerHTML = '<button type="button" class="mpn-info-pop__x" aria-label="' + esc(CLOSE) + '">×</button><p class="mpn-info-pop__t"></p><div class="mpn-info-pop__b"></div>';
    pop.querySelector('.mpn-info-pop__x').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(); });
    document.body.appendChild(pop);
    return pop;
  }
  function place() {
    if (!pop || pop.hidden || !cur || !cur.isConnected) return;
    var r = cur.getBoundingClientRect(), w = pop.offsetWidth, vw = document.documentElement.clientWidth;
    var left = r.left + r.width / 2 - 24;
    left = Math.max(16, Math.min(left, vw - w - 16));
    pop.style.left = (left + window.pageXOffset) + 'px';
    pop.style.top = (r.bottom + 10 + window.pageYOffset) + 'px';
  }
  function setOn(b, on) {
    if (!b) return;
    if (b.hasAttribute('aria-expanded') || b.tagName === 'BUTTON') b.setAttribute('aria-expanded', on ? 'true' : 'false');
    b.classList.toggle('mpn-info-on', on);
  }
  function open(b) {
    var c = content(b);
    if (!c.h && !c.t) return false;
    ensure();
    if (cur && cur !== b) setOn(cur, false);
    cur = b; setOn(b, true);
    var tt = pop.querySelector('.mpn-info-pop__t');
    tt.textContent = c.t; tt.hidden = !c.t;
    pop.querySelector('.mpn-info-pop__b').innerHTML = c.h;
    pop.hidden = false;
    place();
    return true;
  }
  function close() { if (pop) pop.hidden = true; setOn(cur, false); cur = null; }
  /* Capture : on passe avant les anciens comportements (ligne dépliée, infobulle, fenêtre) */
  function onClick(e) {
    var b = e.target.closest && e.target.closest(SEL);
    if (b) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (cur === b && pop && !pop.hidden) { close(); return; }
      open(b);
      return;
    }
    if (pop && !pop.hidden && !pop.contains(e.target)) close();
  }
  document.addEventListener('click', onClick, true);
  /* l'ancienne infobulle « découpes » / « surface test » s'ouvrait aussi au survol ou au toucher */
  ['mouseover', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target.closest && e.target.closest('.product__cuttings-info,.sample-block__info');
      if (t) { e.stopPropagation(); t.classList.remove('is-active'); }
    }, true);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.addEventListener('resize', place);
  /* les « i » sans texte n'apparaissent pas (aucune bulle vide) */
  function keyboard() {
    document.querySelectorAll('.product__cuttings-info,.sample-block__info').forEach(function (el) {
      if (!el.hasAttribute('tabindex')) { el.setAttribute('tabindex', '0'); el.setAttribute('role', 'button'); }
    });
  }
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.product__cuttings-info,.sample-block__info')) { e.preventDefault(); e.target.click(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', keyboard); else keyboard();
})();
